import { Link } from "react-router-dom";
import "./routeErrorElement.css";

export default function AppErrorScreen({
  title = "This screen could not be rendered.",
  message = "Something went wrong while loading this page.",
  statusCode = 500,
}) {
  return (
    <main className="routeError-root">
      <section className="routeError-card" role="alert" aria-live="assertive">
        <p className="routeError-eyebrow">Something went wrong on our side</p>
        <h1 className="routeError-title">{title}</h1>
        <p className="routeError-body">{message}</p>

        <div className="routeError-meta">
          <span className="routeError-pill">Error {statusCode}</span>
          <button
            type="button"
            className="routeError-button routeError-button-secondary"
            onClick={() => window.location.reload()}
          >
            Reload page
          </button>
          <Link className="routeError-button routeError-button-primary" to="/">
            Back to home
          </Link>
        </div>
      </section>
    </main>
  );
}